import { render, staticRenderFns } from "./treatmentNorditropin.vue?vue&type=template&id=1fe66994&scoped=true&"
import script from "./treatmentNorditropin.vue?vue&type=script&lang=js&"
export * from "./treatmentNorditropin.vue?vue&type=script&lang=js&"
import style0 from "./treatmentNorditropin.vue?vue&type=style&index=0&id=1fe66994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe66994",
  null
  
)

export default component.exports